var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.27 637.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #2abd00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m637.27,318.25c.19,176-143.02,319.23-319.02,319.02C143.14,637.06.2,494.13,0,319.01-.2,143.02,143.02-.2,319.01,0c175.12.2,318.05,143.14,318.26,318.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m442.21,278.68l-127.3,127.3c-16.35,16.35-42.86,16.35-59.21,0l-60.63-60.63c-13.02-13.02-13.02-34.12,0-47.14s34.12-13.02,47.14,0l43.1,43.1,109.76-109.76c13.02-13.02,34.12-13.02,47.14,0,13.02,13.02,13.02,34.11,0,47.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.c4fa1d539a2f749eceeb51d6eeac680f.svg";
export { ForwardRef as ReactComponent };